import { IService } from '../../../../partner-pages/types';

export const customWhenRequiredMap: Record<string, IService[]> = {
  prod_itr_af_basic: [
    {
      id: 1001,
      richText: '<p>Direct Interaction with Expert</p>',
      serviceImage: '',
    },
    {
      id: 1002,
      richText: '<p>Tax calculation walkthrough</p>',
      serviceImage: '',
    },
    {
      id: 1003,
      richText: '<p>Filing done in 24 hours</p>',
      serviceImage: '',
    },
  ],

  prod_itr_af_premium: [
    {
      id: 2001,
      richText: '<p>Video Call with Expert *</p>',
      serviceImage: '',
    },
    {
      id: 2002,
      richText: '<p>Tax calculation walkthrough</p>',
      serviceImage: '',
    },
    {
      id: 2003,
      richText: '<p>Graphical Tax Reports</p>',
      serviceImage: '',
    },
  ],

  prod_itr_af_black: [
    {
      id: 3001,
      richText: '<p>Tax filing in direct video call *</p>',
      serviceImage: '',
    },
    {
      id: 3002,
      richText: '<p>Tax calculation walkthrough</p>',
      serviceImage: '',
    },
    {
      id: 3003,
      richText: '<p>Next year tax planning in video call</p>',
      tooltip: `<ul class='list-disc pl-4'>
          <li>Tax saving session for next year (Sep-Apr)</li>
          <li>Tips on saving from <ul class='list-disc pl-4'>
            <li>80C/80D/NPS allocations</li>
            <li>Tax loss harvesting for Capital Gains</li>
            <li>FnO Loss Offsets</li>
          </ul></li>
        </ul>`,
    },
  ],
  prod_itr_af_luxury: [
    {
      id: 1700,
      richText: '<p>Tax filing - Unlimited video calls *</p>',
      serviceImage: '',
    },
    {
      id: 1701,
      richText: '<p>Tax calculation walkthrough</p>',
      serviceImage: '',
    },
    {
      id: 1702,
      richText: '<p>Next year tax planning - monthly advisory video calls</p>',
      tooltip: `<ul class='list-disc pl-4'>
          <li>Monthly tax saving reviews</li>
          <li>Custom services:
            <ul class='list-disc pl-4'>
              <li>Advance Tax payment</li>
              <li>TDS deduction on rent</li>
              <li>NRI taxation</li>
              <li>HUF Setup</li>
              <li>ESOP/RSU cash-outs</li>
            </ul>
          </li>
          <li>Notice defence</li>
        </ul>`,
    },
    {
      id: 1703,
      richText: '<p>Dedicated priority support</p>',
      serviceImage: '',
    },
  ],

  prod_ask_expert_plan: [
    {
      id: 3001,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Get answers to your tax related queries</span></p>',
      serviceImage: '',
    },
    {
      id: 3002,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Personalised tax planning</span></p>',
      serviceImage: '',
    },
    {
      id: 3003,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">One-on-one consultation with senior tax expert</span></p>',
      serviceImage: '',
    },
    {
      id: 3004,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Dedicated relationship manager</span></p>',
      serviceImage: '',
    },
  ],

  // Add whenRequired for advance tax calculation plan
  prod_advance_tax_calculation: [
    {
      id: 3006,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Avoid interest under 234B/234C with proactive planning</span></p>',
      serviceImage: '',
    },
    {
      id: 3007,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Expert review of your tax calculation</span></p>',
      serviceImage: '',
    },
    {
      id: 3008,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Guidance on quarterly payment schedules</span></p>',
      serviceImage: '',
    },
    {
      id: 3009,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Calculation of Advance taxes for one quarter</span></p>',
      serviceImage: '',
    },
  ],

  prod_huf_suite: [
    {
      id: 3006,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">HUF Deed and Draft Filing</span></p>',
      serviceImage: '',
    },
    {
      id: 3007,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">PAN Application</span></p>',
      serviceImage: '',
    },
    {
      id: 3008,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Stamp Creation</span></p>',
      serviceImage: '',
    },
    {
      id: 3009,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">HUF Bank Account Setup</span></p>',
      serviceImage: '',
    },
    {
      id: 3010,
      richText: '<p><span style="color: rgb(0, 0, 0);">HUF Advisory</span></p>',
      serviceImage: '',
    },
    {
      id: 3011,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Annual HUF ITR Filing</span></p>',
      serviceImage: '',
    },
  ],

  // Add whenRequired for tax notice management plan
  prod_tax_notice_management_plan: [
    {
      id: 3010,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Covers notices under Sections 139(9),143(1)</span></p>',
      serviceImage: '',
    },
    {
      id: 3012,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Notice response - drafted and filed</span></p>',
      serviceImage: '',
    },
  ],

  // Add whenRequired for HUF registration plan
  prod_huf: [
    {
      id: 4010,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">HUF Deed and Draft Filing</span></p>',
      serviceImage: '',
    },
    {
      id: 4011,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">PAN Application</span></p>',
      serviceImage: '',
    },
    {
      id: 4012,
      richText:
        '<p><span style="color: rgb(0, 0, 0);">Stamp Creation</span></p>',
      serviceImage: '',
    },
  ],
};

export const customServicesIncludedMap: Record<string, IService[]> = {
  prod_itr_af_basic: [
    {
      id: 1004,
      richText: `
        <p><strong>For Income Sources:</strong></p>
        <ul class='list-disc pl-4'>
          <li>Salary income &lt; 50 L</li>
          <li>Interest Income (Savings, Term deposits)</li>
        </ul>
        <p><strong>Excluded Income Sources:</strong></p>
        <p>Capital Gains, FnO, Business Income, Crypto</p>
      `,
      serviceImage: '',
    },
  ],

  prod_itr_af_premium: [
    {
      id: 2004,
      richText: `
        <p><strong>For Income Sources:</strong></p>
        <ul class='list-disc pl-4'>
          <li>Salary and Interest Income – any range</li>
          <li>Capital gains (Stocks, Mutual funds, FnO, Intraday, Crypto, Property)</li>
          <li>Freelance, Online gaming</li>
        </ul>
      `,
      serviceImage: '',
    },
  ],

  prod_itr_af_black: [
    {
      id: 3005,
      richText: `
         <p><strong>For Income Sources:</strong></p>
         <ul class='list-disc pl-4'>
          <li>All income sources covered</li>
          (Includes NRI, ESOPs, RSUs, Foreign income, Business income)
        </ul>
      `,
      serviceImage: '',
    },
  ],

  prod_itr_af_luxury: [
    {
      id: 4001,
      richText: `
        <p><strong>For Income Sources:</strong></p>
        <ul class='list-disc pl-4'>
          <li>All income sources covered</li>
          (Includes NRI, ESOPs, RSUs, Foreign income, Business income)
        </ul>
      `,
      serviceImage: '',
    },
  ],

  // Add servicesIncluded for our new plans
  prod_ask_expert_plan: [],
  prod_advance_tax_calculation: [],
  prod_tax_notice_management_plan: [],
  prod_huf: [],
};

// Custom name map for plan heading customizations
export const customNameMap: Record<string, string> = {
  prod_ask_expert_plan: ' - Ask Our Expert',
  prod_advance_tax_calculation: ' - Advance Tax Planning',
  prod_tax_notice_management_plan: ' - Notice Management',
  prod_huf: ' - HUF Registration',
  prod_huf_suite: ' - HUF Suite',
  prod_reg_GST: 'GST Registration',
};

// Custom shortDescription map for plan subheading customizations
export const customShortDescriptionMap: Record<string, string> = {
  prod_ask_expert_plan: 'Get personalized tax advice from experts',
  prod_advance_tax_calculation: 'Estimate & Manage Advance Tax Payments',
  prod_tax_notice_management_plan: 'End-to-End Help for Income Tax Notices',
  prod_huf: 'Complete HUF setup and registration',
  prod_reg_GST: 'Fast and reliable GST registration service',
  prod_huf_suite:
    'End-to-end HUF services: Formation, Banking, Advisory & Filing',
};

// Custom buy link map for plan purchase links
export const customBuyLinkMap: Record<string, string> = {};

// Custom know more link map for plan details links
export const customKnowLinkMap: Record<string, string> = {};
